interface IProps {
  className?: string;
  children: any;
  style?: React.CSSProperties;
}

export function Card({ className, children, style }: IProps) {
  return (
    <div className={`card ${className}`} style={style}>
      {children}
    </div>
  );
}
